import Spinner from "./spinner"

const PageLoader = () => (
    <div className="w-full flex-grow grid place-items-center">
        <Spinner color={"text-zinc-300"} />
    </div>
)

export default PageLoader